import { Button, Stack, Typography, useTheme } from '@mui/material'
import Grid from '@mui/material/Grid'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'
import { getLocalUser } from 'utils/localStorage'
import moment from 'moment'
import { formatDayMonthDay, getCurrentGreetings } from 'utils/formatDateTime'
import RowStack from 'components/atoms/container/RowStack'
import { MONARK_SUPPORT_EMAIL } from 'utils/constants'
import JumpToGoalButton from 'components/molecules/home/JumpToGoalButton'

const WelcomeBanner = ({ showJouneyButton = false, showUpgradeButton }) => {
  const { t, i18n } = useTranslation()
  const localUser = getLocalUser()
  const theme = useTheme()
  return (
    <Grid
      container
      size={12}
      sx={{
        borderRadius: 2.5,
        backgroundColor: colors.GoldenYellow50,
        padding: 10
      }}>
      {/*  Header */}
      <Grid size={{ sm: 12, md: 9 }} display='flex' alignItems='center'>
        <Stack padding={6}>
          <Typography>
            {formatDayMonthDay(moment(), i18n.resolvedLanguage)}
          </Typography>
          <Typography variant='h1'>
            {`${t(getCurrentGreetings())}, ${localUser?.firstName || localUser.email}! 👋`}
          </Typography>
          <Typography>
            {localUser.organization?.name || ''}
          </Typography>
        </Stack>
      </Grid>

      {/*  This part should be removed on my journey page release */}
      {showUpgradeButton && (
        <Grid
          size={{ sm: 12, md: 6 }}
          sx={{
            borderRadius: 4,
            backgroundColor: theme,
            padding: 16
          }}>
          <RowStack>
            <Typography variant='h3'>
              {t('welcomeArea.unlockAndUpgrade')}
            </Typography>
            <Button
              sx={{ width: 280 }}
              href={`mailto:${MONARK_SUPPORT_EMAIL}?subject=${encodeURIComponent(t('welcomeArea.raterOnlySubject'))}`}>
              {t('welcomeArea.upgradeMonark')}
            </Button>
          </RowStack>
        </Grid>
      )}

      {showJouneyButton && (
        <Grid size={{ sm: 12, md: 3 }} alignSelf={'center'}>
          <JumpToGoalButton />
        </Grid>
      )}
    </Grid>
  )
}

export default WelcomeBanner
